import { api } from "@/lib/api"

/** Uploads a picked logo and resolves the persistent URL to store on the row. */
export function usePortalLogoUpload() {
	const getSignedUrl = api.file.getUrl.useMutation()

	return async (file: File): Promise<string> => {
		const { fileUrl, uploadUrl } = await getSignedUrl.mutateAsync({
			fileName: file.name,
			fileType: file.type,
		})
		const res = await fetch(uploadUrl, {
			method: "PUT",
			body: file,
			headers: { "Content-Type": file.type },
		})
		if (!res.ok) throw new Error("Logo upload failed.")
		return fileUrl
	}
}
